import { RequestImportForm } from "./RequestImportForm.js";

export function ZOCDOC() {
  const children = {
    RequestImportForm: RequestImportForm(
      {
        platform: "zocdoc",
        platform_name: "ZOCDOC",
      },
      "zocdoc"
    ),
  };

  function render() {
    return /*html*/ `
        <div class="bg-white rounded-lg border border-gray-200 py-4 px-4 w-full dark:bg-neutral-800 dark:border-neutral-700">
            <div class="flex items-center justify-between gap-3">
                <div class="flex flex-col items-start gap-1">
                    <h3
                        class="text-slate-900 text-base font-semibold font-['Inter'] dark:text-white">
                        Request to import reviews from ZOCDOC</h3>
                    <p class="text-gray-600 text-sm font-[300] dark:text-gray-400 hidden">We will
                        manually import all the feeds for you.</p>
                </div>
            </div>
            <div class="mt-4 max-w-full">
                ${children.RequestImportForm.render()}
            </div>
            <div class="mt-4 bg-gray-50 border border-gray-200 text-sm text-gray-600 rounded-lg p-4 dark:bg-white/10 dark:border-white/10 dark:text-neutral-400"
                role="alert" tabindex="-1" aria-labelledby="hs-soft-color-secondary-label">
                <div class="flex gap-2">
                    <svg class="size-5 shrink-0" xmlns="http://www.w3.org/2000/svg" width="24"
                        height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide lucide-info">
                        <circle cx="12" cy="12" r="10" />
                        <path d="M12 16v-4" />
                        <path d="M12 8h.01" />
                    </svg>
                    <p> We are currently working to automate review import process. If you want to import any reviews from ZOCDOC, request us by pasting your review link.</p>                </div>
                <div class="mt-4 text-sm">
                    <ol class="list-decimal space-y-2 ps-10">
                        <li>Request to import by entering your ZOCDOC link.</li>
                        <li>Our engineering team will scrap reviews within 48 hours.</li>
                        <li>We will email you once reviews are available to view in your account.</li>
                        <li>You can then use those reviews to create a Wall of Love & embed them on your website.</li>
                        <li>Feel free to chat with us if you need any help by clicking the bottom-right bubble.</li>
                    </ol>                </div>
            </div>
        </div>
        <!-- Card -->
        <a href="https://help.feedspace.io/en/category/tutorials-1uf70pn/" target="_blank" class="mt-4 bg-white overflow-hidden border border-gray-200 shadow-sm rounded-xl dark:bg-neutral-800 dark:border-neutral-700 block hidden">
            <div class="grid mob:grid-cols-12 gap-4">
                <div class="mob:col-span-5 mob:order-2 hidden mob:block">
                    <div
                        class="bg-gradient-to-r from-blue-300 to-blue-700 overflow-hidden h-full p-4">
                        <div class="rounded-md overflow-hidden">
                            <img class="w-full h-auto max-w-full" src="/images/Manual-import.svg" alt="Custom Domain Setup"/>
                        </div>
                    </div>
                </div>
                <!-- End Col -->

                <div class="mob:col-span-7 mob:order-1 p-5">
                    <div class="h-full flex flex-col justify-between space-y-3">
                        <div>
                            <h3
                                class="text-base font-semibold text-gray-800 dark:text-neutral-200">
                                This is a heading on How to Manual import will Work?
                            </h3>
                            <p
                                class="mt-1 sm:mt-3 text-sm text-gray-500 dark:text-neutral-500">
                                Copy the code below and add to your website section wherever
                                you want to show Review Form.
                            </p>
                        </div>
                        <p class="mt-10">
                            <span class="inline-flex items-center gap-x-1 text-sm text-blue-600 decoration-2 hover:underline font-medium focus:outline-none focus:underline dark:text-blue-400 dark:hover:text-blue-500">
                                View Tutorial
                                <svg class="shrink-0 size-4"
                                    xmlns="http://www.w3.org/2000/svg" width="24"
                                    height="24" viewBox="0 0 24 24" fill="none"
                                    stroke="currentColor" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round"
                                    class="lucide lucide-arrow-right">
                                    <path d="M5 12h14" />
                                    <path d="m12 5 7 7-7 7" />
                                </svg>
                            </span>
                        </p>
                    </div>
                </div>
                <!-- End Col -->
            </div>
        </a>
        <!-- End Card -->
        `;
  }

  return {
    render,
    children,
  };
}
